export const bookingReportPage = {
  id: 'property-center-bookingreport',
  name: _TL_('Bookings'),
  route: 'propertycenter/bookingreport',
};
